import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fetchCountries } from '../store/countryStore/countryThunk';
import dialCodes from '../assets/countries.json';

/** Dial code for the selected account's Country Of Reg., e.g. "+91". Empty when it can't be resolved. */
export default function useAccountDialCode(): string {
  const dispatch = useAppDispatch();
  const { selectedAccount } = useAppSelector(state => state.auth);
  const countries = useAppSelector(state => state.country.countries);

  useEffect(() => { dispatch(fetchCountries()); }, [dispatch]);

  return useMemo(() => {
    // Login doesn't populate countryOfRegistration, so it's usually a raw id.
    const reg = (selectedAccount as any)?.countryOfRegistration;
    const regId = reg?._id || reg;
    const country: any = (countries || []).find((c: any) => c._id === regId);
    if (!country) return '';
    const match = (dialCodes as any[]).find(c => c.code === country.code1 || c.code === country.code2
      || c.name?.toLowerCase() === country.name?.toLowerCase());
    return match?.dial_code || '';
  }, [countries, selectedAccount]);
}

/** Prefixes a typed number with the account dial code, leaving already-prefixed values alone. */
export function withDialCode(phone: string | undefined, dialCode: string): string {
  const trimmed = (phone || '').trim();
  return trimmed && dialCode && !trimmed.startsWith('+') ? `${dialCode}${trimmed}` : trimmed;
}

/** Drops the account dial code from a stored number so the field shows only the digits. */
export function stripDialCode(phone: string | undefined, dialCode: string): string {
  const trimmed = (phone || '').trim();
  return dialCode && trimmed.startsWith(dialCode) ? trimmed.slice(dialCode.length).trim() : trimmed;
}
